// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ViewSubCategory-viewSubCategoryItemImgContainer-nB48s {
    position: relative;
    width: 100%;
    height: 148px;
    border-radius: 0 var(--radius-2) 0 var(--radius-2);
}

.ViewSubCategory-viewSubCategoryItemImgContainer-nB48s img {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    -o-object-fit: cover;
       object-fit: cover;
    -o-object-position: center;
       object-position: center;
    border-radius: inherit;
}

.ViewSubCategory-viewSubCategoryItemInfoContainer-a7kpt {
    margin-top: 12px;
}

.ViewSubCategory-viewSubCategoryItemInfoTitle-pwxDp,
.ViewSubCategory-viewSubCategoryItemInfoSpecialText-DcVKM {
    font-size: 16px;
    line-height: 26px;
    text-align: start;
}

.ViewSubCategory-viewSubCategoryItemInfoTitle-pwxDp {
    font-weight: 700;
}

.ViewSubCategory-viewSubCategoryItemInfoTitle-pwxDp {
    color: var(--primary-foreground);
}

.ViewSubCategory-viewSubCategoryItemInfoSpecialText-DcVKM {
    color: var(--primary-bg);
    margin-bottom: 3px;
    font-weight: 600;
}

.ViewSubCategory-viewSubCategoryItemInfoDesc-jGboE {
    color: var(--secondary-foreground);
    font-size: 14px;
    line-height: 24px;
    font-weight: 400;
    margin-bottom: 3px;
    text-align: start;
}

.ViewSubCategory-viewSubCategoryItemInfoLink-lkLzx {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    margin-bottom: 12px;
}

.ViewSubCategory-viewSubCategoryRangeBtn-uPgBE {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    -webkit-box-pack: start;
        -ms-flex-pack: start;
            justify-content: flex-start;
    gap: 18px;
    grid-gap: 18px;
    font-size: 18px;
    font-weight: 600;
    line-height: 28px;
    color: var(--primary-foreground);
}

.ViewSubCategory-viewSubCategoryRangeBtnIcon-QPwHV {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    -webkit-box-pack: center;
        -ms-flex-pack: center;
            justify-content: center;
    width: 44px;
    height: 44px;
    border-radius: 50%;
    background: var(--primary-bg);
    cursor: pointer;
}

.ViewSubCategory-viewSubCategoryRangeDisabledBtnIcon-JTgqK {
    background: var(--secondary-disable);
    cursor: not-allowed;
}`, "",{"version":3,"sources":["webpack://./src/components/ViewCategory/ViewSubCategory/ViewSubCategory/ViewSubCategory.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,kDAAkD;AACtD;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,oBAAiB;OAAjB,iBAAiB;IACjB,0BAAuB;OAAvB,uBAAuB;IACvB,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;;IAEI,eAAe;IACf,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,wBAAwB;IACxB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,kCAAkC;IAClC,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,uBAA2B;QAA3B,oBAA2B;YAA3B,2BAA2B;IAC3B,SAAS;IACT,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,gCAAgC;AACpC;;AAEA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,wBAAuB;QAAvB,qBAAuB;YAAvB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,6BAA6B;IAC7B,eAAe;AACnB;;AAEA;IACI,oCAAoC;IACpC,mBAAmB;AACvB","sourcesContent":[".viewSubCategoryItemImgContainer {\n    position: relative;\n    width: 100%;\n    height: 148px;\n    border-radius: 0 var(--radius-2) 0 var(--radius-2);\n}\n\n.viewSubCategoryItemImgContainer img {\n    position: absolute;\n    inset: 0;\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    object-position: center;\n    border-radius: inherit;\n}\n\n.viewSubCategoryItemInfoContainer {\n    margin-top: 12px;\n}\n\n.viewSubCategoryItemInfoTitle,\n.viewSubCategoryItemInfoSpecialText {\n    font-size: 16px;\n    line-height: 26px;\n    text-align: start;\n}\n\n.viewSubCategoryItemInfoTitle {\n    font-weight: 700;\n}\n\n.viewSubCategoryItemInfoTitle {\n    color: var(--primary-foreground);\n}\n\n.viewSubCategoryItemInfoSpecialText {\n    color: var(--primary-bg);\n    margin-bottom: 3px;\n    font-weight: 600;\n}\n\n.viewSubCategoryItemInfoDesc {\n    color: var(--secondary-foreground);\n    font-size: 14px;\n    line-height: 24px;\n    font-weight: 400;\n    margin-bottom: 3px;\n    text-align: start;\n}\n\n.viewSubCategoryItemInfoLink {\n    display: flex;\n    align-items: center;\n    margin-bottom: 12px;\n}\n\n.viewSubCategoryRangeBtn {\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n    gap: 18px;\n    grid-gap: 18px;\n    font-size: 18px;\n    font-weight: 600;\n    line-height: 28px;\n    color: var(--primary-foreground);\n}\n\n.viewSubCategoryRangeBtnIcon {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 44px;\n    height: 44px;\n    border-radius: 50%;\n    background: var(--primary-bg);\n    cursor: pointer;\n}\n\n.viewSubCategoryRangeDisabledBtnIcon {\n    background: var(--secondary-disable);\n    cursor: not-allowed;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"viewSubCategoryItemImgContainer": `ViewSubCategory-viewSubCategoryItemImgContainer-nB48s`,
	"viewSubCategoryItemInfoContainer": `ViewSubCategory-viewSubCategoryItemInfoContainer-a7kpt`,
	"viewSubCategoryItemInfoTitle": `ViewSubCategory-viewSubCategoryItemInfoTitle-pwxDp`,
	"viewSubCategoryItemInfoSpecialText": `ViewSubCategory-viewSubCategoryItemInfoSpecialText-DcVKM`,
	"viewSubCategoryItemInfoDesc": `ViewSubCategory-viewSubCategoryItemInfoDesc-jGboE`,
	"viewSubCategoryItemInfoLink": `ViewSubCategory-viewSubCategoryItemInfoLink-lkLzx`,
	"viewSubCategoryRangeBtn": `ViewSubCategory-viewSubCategoryRangeBtn-uPgBE`,
	"viewSubCategoryRangeBtnIcon": `ViewSubCategory-viewSubCategoryRangeBtnIcon-QPwHV`,
	"viewSubCategoryRangeDisabledBtnIcon": `ViewSubCategory-viewSubCategoryRangeDisabledBtnIcon-JTgqK`
};
module.exports = ___CSS_LOADER_EXPORT___;
